import { render } from "./Ranking.vue?vue&type=template&id=32b29a43&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"

import "./Ranking.vue?vue&type=style&index=0&id=32b29a43&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32b29a43"

export default script